// extracted by mini-css-extract-plugin
module.exports = {"header":"Home_header__2cPXP","centeredDiv":"Home_centeredDiv__1oQ2h"};